import xhr from './xhr.js';

const updateForm = async (avatar, userName) => {
    if(!(avatar instanceof Element) || !(userName instanceof Element))
        return;

    const { body } = await xhr.get(`/auth/login.php?resolve=1&name=${encodeURIComponent(userName.value)}`, { type: 'json' });

    avatar.src = body.avatar;
    if(body.name.length > 0)
        userName.value = body.name;
};

for(const form of Array.from(document.querySelectorAll('.js-login-form'))) {
    const avatar = form.querySelector('.js-login-avatar');
    const userName = form.querySelector('.js-login-username');
    let timeOut;

    updateForm(avatar, userName);

    userName.addEventListener('input', function() {
        if(timeOut) {
            clearTimeout(timeOut);
            timeOut = undefined;
        }

        timeOut = setTimeout(() => {
            updateForm(avatar, userName)
                .finally(() => { timeOut = undefined; });
        }, 500);
    });
}
